import {
  Accessibility, AirVent, ArrowUpDown, Baby, Bath, BatteryCharging, BugOff, Cable, Car, Cat, Check, Coffee,
  Container, CookingPot, Dog, DoorOpen, Droplets, Dumbbell, Fan, Fence, Flame, Flower2, GlassWater, Laptop, Lock,
  Microwave, Mountain, Package, PawPrint, Satellite, ShieldCheck, Shirt, ShowerHead, Snowflake, Sparkles, Speaker,
  Sun, Thermometer, TreePalm, Trees, Tv, Utensils, UtensilsCrossed, WashingMachine, Waves, Wifi, Zap,
  type LucideProps,
} from "lucide-react";

// The registry names icons as strings so it stays a pure module; this is the
// one place those names meet components. Unknown names fall back to a check.
const ICONS: Record<string, React.ComponentType<LucideProps>> = {
  Accessibility, AirVent, ArrowUpDown, Baby, Bath, BatteryCharging, BugOff, Cable, Car, Cat, Check, Coffee,
  Container, CookingPot, Dog, DoorOpen, Droplets, Dumbbell, Fan, Fence, Flame, Flower2, GlassWater, Laptop, Lock,
  Microwave, Mountain, Package, PawPrint, Satellite, ShieldCheck, Shirt, ShowerHead, Snowflake, Sparkles, Speaker,
  Sun, Thermometer, TreePalm, Trees, Tv, Utensils, UtensilsCrossed, WashingMachine, Waves, Wifi, Zap,
};

const AmenityIcon = ({ name, className, ...props }: { name: string } & LucideProps) => {
  const Icon = ICONS[name] ?? Check;
  return <Icon className={className} aria-hidden {...props} />;
};

export default AmenityIcon;
